<template>
  <div class="carousel">
    <div class="carousel-inner" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <slot v-for="(slide, index) in slides" :key="index" name="slide" :slide="slide"></slot>
    </div>
    <div class="carousel-indicators" v-if="props.isShowIndicators">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="carousel-indicator"
        :class="{ active: index === currentIndex }"
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineSlots, onMounted, defineProps } from 'vue'

const props = defineProps({
  slides: { // 轮播图数据
    type: Array,
    required: true
  },
  isShowIndicators: { // 是否显示指示器
    type: Boolean,
    default: true
  },
  intervalTime: { // 轮播时间，为0时不轮播
    type: Number,
    default: 5000
  }
})

const slots = defineSlots()

const currentIndex = ref(0)

const nextSlide = () => {
  if (currentIndex.value < props.slides.length - 1) {
    currentIndex.value++
  } else {
    currentIndex.value = 0
  }
}

const prevSlide = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--
  } else {
    currentIndex.value = props.slides.length - 1
  }
}

const goToSlide = (index) => {
  currentIndex.value = index
}

onMounted(() => {
  if(props.intervalTime) {
    setInterval(() =>{
      nextSlide()
    }, props.intervalTime);
  }
});

</script>

<style scoped>
.carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.carousel-inner > * {
  flex: 0 0 100%;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
}

.carousel-control {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.carousel-control:hover {
  opacity: 1;
}

.carousel-control:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.carousel-indicators {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 35px;
  align-items: center;
}

.carousel-indicator {
  background-color: rgba(23, 26, 29, 0.24);
  border: none;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.active {
  background-color: rgba(23, 26, 29, 0.8);
  width: 12px;
  height: 12px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .carousel-indicators {
    margin-top: 14px;
  }
  .carousel-indicator {
    width: 7px;
    height: 7px;
  }
  .active{
     width: 10px;
     height: 10px;
  }
}

</style>
